// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles__tab___3EzA4","active":"styles__active___3AupB styles__tab___3EzA4"};